import * as React from "react"
import { Input as InputPrimitive } from "@base-ui/react/input"

import { cn } from "@/frontend/lib/utils"

/** Shared base classes for all text-input-like controls. */
export const inputStyles =
  "rounded-lg border border-input bg-card text-sm transition-colors outline-none placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/50 disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50 aria-invalid:border-destructive-fg aria-invalid:ring-1 aria-invalid:ring-destructive-border aria-invalid:focus-visible:border-destructive-fg aria-invalid:focus-visible:ring-2 aria-invalid:focus-visible:ring-destructive-border"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <InputPrimitive
      type={type}
      data-slot="input"
      className={cn(
        inputStyles,
        "h-8 w-full min-w-0 px-2.5 py-1 file:inline-flex file:h-6 file:border-0 file:bg-transparent file:file:font-medium file:text-foreground",
        className
      )}
      {...props}
    />
  )
}

export { Input }
